export default "__VITE_ASSET__Dtw3m5wp__"